import { render, staticRenderFns } from "./GroupLinkCompanyDialog.vue?vue&type=template&id=0a055c55&scoped=true&"
import script from "./GroupLinkCompanyDialog.vue?vue&type=script&lang=js&"
export * from "./GroupLinkCompanyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a055c55",
  null
  
)

export default component.exports